import useAuthStorage from '@/common/store/authStorage/useAuthStorage.ts';
import { useQueryClient } from '@tanstack/react-query';

const useAuth = () => {
  const removeToken = useAuthStorage((state) => state.removeToken);
  const setToken = useAuthStorage((state) => state.setToken);
  const hasToken = !!useAuthStorage((state) => state.token);
  const queryClient = useQueryClient();
  const logOut = () => {
    removeToken();
    queryClient.clear();
  };

  const login = (token: string) => {
    setToken(token);
  };
  return {
    logOut,
    login,
    hasToken,
  };
};

export default useAuth;
